import Clip from '@/models/Clip'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
  },

  mutations: {
    setClipList(state, clips) {
      each(clips, (clip) => {
        const exist = find(state.list, { id: clip.id })
        if (!exist) {
          state.list.push(new Clip(clip))
        }
      })
    },

    clearClipList(state) {
      state.list = []
    },

    clearClipDetails(state) {
      state.clipDetails = null
    },

    setClipListMeta(state, meta) {
      state.listMeta = meta
    },

    setClipDetails(state, clip) {
      if (clip instanceof Clip) {
        state.clipDetails = clip
      } else {
        state.clipDetails = new Clip(clip)
      }
    },
  },

  actions: {
    async getClips({ commit }, params) {
      const query = Clip.page(params.page || 1).orderBy(params.sort)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query
        .params({ limit: 20, 'filter[type]': params.type })
        .get()

      commit('setClipList', res.data)
      commit('setClipListMeta', res.meta)
    },

    async getClipDetails({ commit }, id) {
      const { data } = await Api.get(`admin/clips/${id}`)
      commit('setClipDetails', data.data)
    },

    async storeClip({ commit }, formData) {
      const { data } = await Api.post(`admin/clips`, formData)
      commit('setClipDetails', data.data)
    },

    async updateClip({ commit }, formData) {
      const { data } = await Api.post(
        `admin/clips/${formData.id}`,
        formData.data
      )

      commit('setClipDetails', data.data)
    },

    async deleteClip({ commit }, id) {
      await Api.delete(`admin/clips/${id}`)
    },
  },

  getters: {
    allClips: (state) => state.list,
    getClipById: (state) => (id) => state.list.find((clip) => clip.id === id),
  },
}
